import React, {useRef} from "react";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {IStatsRow} from "components/dashboard/dataset-window/models/interfaces";
import {Button} from "primereact/button";

const Stats = ({statsArr}: { statsArr: Array<IStatsRow> }) => {
    const dt = useRef<DataTable>(null);
    const maxDatasetPerPage = 10;

    const exportCSV = () => {
        dt.current?.exportCSV({selectionOnly: false});
    }

    return <div className={"flex flex-column gap-2"}>
        <Button type="button"
                icon="pi pi-file"
                onClick={exportCSV}
                className="ml-auto p-button-sm"
                data-pr-tooltip="CSV"
                label={"CSV"}
        />
        <DataTable
            ref={dt}
            value={statsArr}
            paginator={statsArr?.length > maxDatasetPerPage}
            responsiveLayout="scroll"
            size={"small"}
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={maxDatasetPerPage}
            showGridlines
        >
            <Column field="title" header="Title" sortable/>
            <Column field="unit" header="Unit" sortable style={{width: 0}}/>
            <Column field="pointCount" header="Count" sortable style={{width: 0}}/>
            <Column field="sum" header="Sum" sortable style={{width: 0}}/>
            <Column field="min" header="Min" sortable style={{width: 0}} body={(data) => data.min ? data.min : "-"}/>
            <Column field="max" header="Max" sortable style={{width: 0}} body={(data) => data.max ? data.max : "-"}/>
            <Column field="delta" header="Delta" sortable style={{width: 0}}
                    body={(data) => data.delta ? data.delta : "-"}/>
            <Column field="mean" header="Mean" sortable style={{width: 0}}
                    body={(data) => data.mean ? data.mean : "-"}/>
            <Column field="std" header="Std" sortable style={{width: 0}} body={(data) => data.std ? data.std : "-"}/>
        </DataTable>
    </div>
};

export default Stats;
